<template>
  <div>
    <div v-if="loading" class="text-xs-center mt-5">
      <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
    </div>
    <div v-else style="display: flex">
      <!-- <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs7> -->
      <Multiselect
        v-model="selectedCategory"
        placeholder="Select category"
        :options="categories"
        label="name"
        @input="$emit('change', $event)"
      ></Multiselect>
      <!-- </v-flex>
        <v-flex xs2> -->
      <v-btn color="grey" icon outline @click="showEditDialog = true"
        ><v-icon color="grey">edit</v-icon></v-btn
      >
      <!-- </v-flex>
      </v-layout> -->
    </div>
    <div>
      <v-dialog v-model="showEditDialog" persistent width="550px">
        <v-card style="position: relative">
          <div class="py-2 pl-2">
            <div style="font-size: 20px; font-weight: 600">Edit category</div>
            <div style="position: absolute; right: 0px; top: 0px" class="text-xs-right">
              <v-btn icon @click="showEditDialog = false"> <v-icon>close</v-icon></v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="px-3 py-3">
            <div>
              <div
                v-if="!isCreate"
                class="category-item-add pa-2 text-xs-center mb-3"
                @click="isCreate = true"
              >
                Create category
              </div>
              <div v-else>
                <div
                  xs12
                  sm6
                  class="form-control pa-1 category-item mb-3"
                  :class="{ 'has-error': errors.has('ชื่อ Category') }"
                >
                  <input
                    v-model="input.name"
                    v-validate="'required'"
                    placeholder="กรอกชื่อ Category"
                    :data-vv-as="$t('ชื่อ Category')"
                    name="ชื่อ Category"
                    class="form-control"
                    type="text"
                  />
                  <span v-if="errors.has('ชื่อ Category')" class="text-error">{{
                    errors.first('ชื่อ Category')
                  }}</span>
                  <div class="text-xs-center">
                    <v-btn color="grey" outline @click="cancelCreate">cancel</v-btn>
                    <v-btn :loading="createLoading" depressed color="primary" @click="saveCreate"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-for="(cat, k) in categories" :key="cat.id" class="category-item pa-2 mb-2">
              <v-layout v-if="!isShowEdit(cat.id)" row wrap class="pa-0 ma-0">
                <v-flex xs12 style="position: relative">
                  <div>{{ cat.name }}</div>
                  <div style="position: absolute; right: 0px; top: -3px">
                    <v-btn small icon class="ma-0" @click="showEditItems.push({ ...cat })">
                      <v-icon color="#8b8b8b" small>edit</v-icon>
                    </v-btn>
                    <v-btn icon small class="ma-0" @click="deleteCategory(cat)">
                      <v-icon color="#8b8b8b" small>delete</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <div v-else>
                <div
                  xs12
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('ชื่อ Category') }"
                >
                  <input
                    v-model="categories[k].name"
                    v-validate="'required'"
                    placeholder="กรอกชื่อ Category"
                    :data-vv-as="$t('ชื่อ Category')"
                    name="ชื่อ Category"
                    class="form-control"
                    type="text"
                  />
                  <span v-if="errors.has('ชื่อ Category')" class="text-error">{{
                    errors.first('ชื่อ Category')
                  }}</span>
                  <div class="text-xs-center">
                    <v-btn color="grey" outline @click="cancelEdit(cat)">cancel</v-btn>
                    <v-btn
                      :loading="isEditLoading(cat.id)"
                      depressed
                      color="primary"
                      @click="saveEdit(cat)"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint'

export default {
  components: {
    Multiselect
  },
  props: {
    campaignId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    categories: {
      get() {
        return this.$store.state.toaEcouponRewardCategories
      },
      set(val) {
        this.$store.state.toaEcouponRewardCategories = val
      }
    }
  },
  data() {
    return {
      showEditItems: [],
      editloading: [],
      createLoading: false,
      showEditDialog: false,
      isCreate: false,
      input: {
        name: ''
      },
      loading: false,
      selectedCategory: ''
    }
  },
  watch: {
    campaignId(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCategory()
      }
    }
  },
  mounted() {
    if (this.campaignId) {
      this.getCategory()
    }
  },
  methods: {
    async getCategory() {
      this.loading = true
      if (!this.campaignId) {
        return
      }

      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        source: 'cms',
        campaignId: this.campaignId,
        campaign_id: this.campaignId
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        data.limit = 99999
        data.offset = 0
        try {
          const response = await toaMegapaintApi.getRewardCategory(data)
          this.categories = response.data.data
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        api.TOAECOUPONGetRewardCategoryByCategoryId(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.categories = response.data
          }
        })
      }
    },
    deleteCategory(cat) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            var data = {
              page_id: this.selectedBot.pageid,
              pageid: this.selectedBot.pageid,
              id: cat.id,
              campaign_id: this.campaignId
            }
            var index = this.categories.findIndex((el) => el.id == cat.id)

            if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
              try {
                await toaMegapaintApi.deleteRewardCategory(data)
                this.categories.splice(index, 1)
              } catch (error) {
                console.error(error)
              } finally {
                this.createLoading = false
              }
            } else {
              api.TOAECOUPONDeleteRewardCategory(data, (err, response) => {
                if (response.responsecode == 200) {
                  this.categories.splice(index, 1)
                }
              })
            }
          }
        })
    },
    isEditLoading(id) {
      return this.editloading.some((el) => el.id == id)
    },
    async saveEdit(cat) {
      var catindex = this.categories.findIndex((el) => el.id == cat.id)
      this.editloading.push(cat)
      var editloadingindex = this.editloading.findIndex((el) => el.id == cat.id)
      var data = {
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid,
        campaign_id: this.campaignId,
        id: cat.id,
        name: cat.name
      }
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.putRewardCategory(data)
          var showindex = this.showEditItems.findIndex((el) => el.id == cat.id)
          this.showEditItems.splice(showindex, 1)
        } catch (error) {
          console.error(error)
        } finally {
          this.editloading.splice(editloadingindex, 1)
        }
      } else {
        api.TOAECOUPONEditRewardCategory(data, (err, response) => {
          this.editloading.splice(editloadingindex, 1)
          if (response.responsecode == 200) {
            var showindex = this.showEditItems.findIndex((el) => el.id == cat.id)
            this.showEditItems.splice(showindex, 1)
          }
        })
      }
    },
    cancelEdit(cat) {
      var showindex = this.showEditItems.findIndex((el) => el.id == cat.id)
      var catindex = this.categories.findIndex((el) => el.id == cat.id)
      this.categories[catindex] = this.showEditItems[showindex]
      this.showEditItems.splice(showindex, 1)
    },
    isShowEdit(id) {
      return this.showEditItems.some((el) => el.id == id)
    },
    cancelCreate() {
      this.isCreate = false
      this.input.name = ''
    },
    async saveCreate() {
      this.createLoading = true
      if (await this.$validator.validateAll()) {
        var data = {
          pageid: this.selectedBot.pageid,
          page_id: this.selectedBot.pageid,
          campaign_id: this.campaignId,
          name: this.input.name
        }

        if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
          try {
            await toaMegapaintApi.postRewardCategory(data)
            this.getCategory()
            this.cancelCreate()
          } catch (error) {
            console.error(error)
          } finally {
            this.createLoading = false
          }
        } else {
          api.TOAECOUPONCreatRewardCategory(data, (err, response) => {
            this.createLoading = false
            if (response.responsecode == 200) {
              this.categories.unshift(response.data)
              this.cancelCreate()
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.category-item {
  position: relative !important;
  border: 1px solid darkgrey !important;
  border-radius: 8px !important;
  background-color: #f4f4f4 !important;
}
.category-item-add {
  position: relative;
  border: 3px dashed #cbcbcb;
  border-radius: 8px;

  color: #b8b8b8;
  font-weight: 600;
  font-size: 22px;
  cursor: pointer;
}
.category-item-add:hover {
  border: 3px dashed rgb(44, 44, 44) !important;
  color: rgb(44, 44, 44);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/RewardCategory.vue